import Button from "components/Button";
import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { format, formatDistance } from "date-fns";
import model from "images/model.jpg";
import {
    budgetType,
    gender,
} from "pages/Profile/EditProfile/PhysicalDetails/constants";
import { FC, useEffect, useState } from "react";
import { BiDollar } from "react-icons/bi";
import { BsHeartFill } from "react-icons/bs";

import {
    IoCalendarClearOutline,
    IoLocationOutline,
    IoMaleFemaleOutline,
} from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "slice";
import { useLikeJobMutation } from "slice/jobs";
import { JobDetails } from "slice/jobs/types";
import theme from "theme";
import {
    AgencyImage,
    CardChip,
    CardContent,
    CardImage,
    CardLeft,
    CardRight,
    CardTitle,
    HorizontalCard,
    Info,
    Posted,
} from "../FindWork.styled";
import logo from "images/logo.svg"
export interface FindWorkCardProps {
    job: JobDetails;
    type: string;
}

export const FindWorkCard: FC<FindWorkCardProps> = ({ job, type }) => {
    const [isHeartActive, setIsHeartActive] = useState(false);
    const navigateTo = useNavigate();
    const { id: userId } = useAppSelector((state) => state.user);
    const [likeJob] = useLikeJobMutation();
    const handleHeartClick = () => {
        setIsHeartActive((prev) => !prev);
        likeJob({
            votable_id: job?.id ?? "",
            votable_type: "Job",
            user_id: userId ?? "",
        });
    };
    useEffect(() => {
        if (job?.is_wishlisted) {
            setIsHeartActive(true);
        } else {
            setIsHeartActive(false);
        }
    }, [job]);
    return (
        <HorizontalCard>
            <CardImage src={job.agency?.company_logo as unknown as string || logo}
                       alt="agency image" />
            <CardContent>
                <CardLeft>
                    <CardTitle>
                        <Text variant="heading4">{job.title}</Text>
                        {/*<CardChip variant="body2">Featured</CardChip>*/}
                    </CardTitle>

                    <Grid row={true} columnGap={2} marginTop={0.5}>
                        <Info>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection:
                                        "column" /* To stack rows vertically */,
                                    alignItems: "center", // Centers content horizontally
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center", // Centers vertically
                                    }}
                                >
                                    <div
                                        style={{
                                            flex: "0 0 auto",
                                            padding: "10px 0 10px 0",
                                            textAlign: "center",
                                        }}
                                    >
                                        <IoMaleFemaleOutline />
                                    </div>
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                        }}
                                    >
                                        <Text
                                            variant="body3"
                                            color={theme.colors.grey.secondary}
                                            style={{
                                                display: "block",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            {job.no_of_seats}{" "}
                                            {
                                                gender[
                                                    job.gender as keyof typeof gender
                                                ]
                                            }
                                        </Text>
                                        <Text
                                            variant="body3"
                                            color={theme.colors.grey.secondary}
                                            style={{
                                                display: "block",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            From {job.applicant_min_age ?? 0} -{" "}
                                            {(job.applicant_max_age ?? 0) +
                                                " " +
                                                (job.applicant_max_age_unit ||
                                                    "years")}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        </Info>
                    </Grid>
                    <Grid row={true} columnGap={2} marginTop={0.5}>
                        <Info>
                            <BiDollar />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {type !== "liked"
                                    ? budgetType[
                                          job.budget_type as keyof typeof budgetType
                                      ]
                                    : budgetType[
                                          (
                                              job?.budget_type as unknown as {
                                                  budget_type: string;
                                              }
                                          )
                                              ?.budget_type as keyof typeof budgetType
                                      ]}
                            </Text>
                        </Info>
                        <Info>
                            <IoLocationOutline />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {job.city + ", " + job.country_name}
                            </Text>
                        </Info>
                        <Info>
                            <IoCalendarClearOutline />
                            <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                {type !== "liked"
                                    ? job.created_at
                                    : format(
                                          new Date(job.created_at),
                                          "dd/MM/yyyy"
                                      )}
                            </Text>
                        </Info>
                    </Grid>
                    <Grid row={true} alignItems="center" marginTop={1}>
                        <AgencyImage
                            src={job.agency?.company_logo as unknown as string || logo}
                            alt="agency image"
                        />
                        <Text variant="body3" color={theme.colors.grey.primary}>
                            {job?.agency?.name}{" "}
                            {/* <Text
                                variant="body3"
                                color={theme.colors.grey.secondary}
                            >
                                (4.2)
                            </Text> */}
                        </Text>
                    </Grid>
                </CardLeft>
                <CardRight>
                    {type !== "liked" && (
                        <BsHeartFill
                            color={isHeartActive ? "#FF0D41" : "#909090"}
                            onClick={handleHeartClick}
                        />
                    )}
                    <Grid row={true} columnGap={2} alignItems="center">
                        {/* <Text
                            variant="body3"
                            color={theme.colors.green.primary}
                        >
                            75% Match
                        </Text> */}
                        <Button
                            variant="outlined"
                            onClick={() => {
                                navigateTo(
                                    routeConstants.findWork.root +
                                        routeConstants.findWork.details,
                                    {
                                        state: {
                                            jobId: job.id,
                                            agencyId: job.agency_id,
                                        },
                                    }
                                );
                            }}
                        >
                            View Casting
                        </Button>
                    </Grid>
                    <Posted variant="body3" color={theme.colors.grey.secondary}>
                        Last Modified:{" "}
                        {formatDistance(new Date(job.updated_at), new Date())}{" "}
                        ago
                    </Posted>
                </CardRight>
            </CardContent>
        </HorizontalCard>
    );
};
